import React from "react";

/**
 * Notification bell with an alert dot (Figma: Supplier V1 topbar).
 * Uses `currentColor` so it inherits the surrounding text colour.
 */
const BellIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.89026 13.4355H9.30592"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7215 6.18795C11.9595 6.18795 12.1951 6.14109 12.4149 6.05004C12.6347 5.95899 12.8344 5.82554 13.0026 5.6573C13.1709 5.48906 13.3043 5.28934 13.3954 5.06953C13.4864 4.84971 13.5333 4.61412 13.5333 4.3762C13.5333 4.13828 13.4864 3.90269 13.3954 3.68287C13.3043 3.46306 13.1709 3.26334 13.0026 3.0951C12.8344 2.92687 12.6347 2.79341 12.4149 2.70236C12.1951 2.61132 11.9595 2.56445 11.7215 2.56445C11.241 2.56445 10.7802 2.75533 10.4404 3.0951C10.1007 3.43487 9.90979 3.8957 9.90979 4.3762C9.90979 4.85671 10.1007 5.31753 10.4404 5.6573C10.7802 5.99707 11.241 6.18795 11.7215 6.18795Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.09805 2.56445C7.2432 2.56433 6.41418 2.85748 5.74943 3.39495C5.08468 3.93242 4.62444 4.68168 4.44557 5.5176L3.26672 11.0193H12.9294L12.3387 8.26542"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BellIcon;
